import { ChartDataSeries } from '../../../infrastructure/widgets/cards/ChartCard';

export interface BarChartProps {
  categories: string[];
  series: ChartDataSeries[];
}

/**
 * BarChart (Legacy DOM Replication)
 * 
 * Replicates the production 'daily-chart' (Lead Velocity).
 * Renders vertical gradient bars for the last 14 days.
 */
export function BarChart({ categories, series }: BarChartProps) {
  // Production behavior: expects exactly 14 days of data, or we pad it.
  // The backend returns a list of days. `categories` contains the ISO dates.
  // `series[0].data` contains the counts.
  
  const counts = series[0]?.data || [];
  const max = Math.max(1, ...counts);

  return (
    <div className="flex-1 flex flex-col h-full w-full">
      <div className="flex-grow flex items-end justify-between gap-1 w-full min-h-[140px]">
        {categories.map((d, i) => {
          const n = counts[i] || 0;
          const h = Math.round((n / max) * 100);
          
          // Format "YYYY-MM-DD" -> "DD/MM" (matching legacy label = d.slice(8) + '/' + d.slice(5,7))
          const label = d.length === 10 ? `${d.slice(8)}/${d.slice(5, 7)}` : d;
          
          return (
            <div 
              key={d}
              className="flex-grow flex flex-col items-center justify-end h-full gap-1 min-w-0 flex-1" 
              title={`${d}: ${n} leads`}
            >
              <span className="text-[9px] text-on-surface-variant/60 h-3 leading-none">
                {n || ''}
              </span>
              <div 
                className="w-full max-w-[20px] bg-gradient-to-t from-primary/60 to-primary rounded-t transition-all duration-300" 
                style={{ height: `${Math.max(h, 4)}%` }}
              ></div>
              <span className="text-[9px] text-on-surface-variant/70 whitespace-nowrap">
                {label}
              </span>
            </div>
          );
        })}
      </div>
      <div className="flex justify-between mt-sm border-t border-outline pt-sm">
        <span className="text-data-md text-on-surface-variant text-[11px]">14d ago</span>
        <span className="text-data-md text-primary text-[11px]">Today</span>
      </div>
    </div>
  );
}
